import {
    GET_PLAYER,
    GET_PLAYER_SUCCESS,
    GET_PLAYER_FAILED,
    GET_DETAILED_CAMPAIGN,
    GET_DETAILED_CAMPAIGN_SUCCESS,
    GET_DETAILED_CAMPAIGN_FAILED,
    GET_PLAYER_LIST,
    GET_PLAYER_LIST_SUCCESS,
    GET_PLAYER_LIST_FAILED
} from './actionTypes';

export const getPlayer = () => {
    return {
        type: GET_PLAYER
    }
}
export const getPlayerSuccess = (player) => {
    return {
        type: GET_PLAYER_SUCCESS,
        payload: player
    }
}

export const getPlayerFailed= () => {
    return {
        type: GET_PLAYER_FAILED
    }
}

export const getPlayerList = () => {
    return {
        type: GET_PLAYER_LIST
    }
}
export const getPlayerListSuccess = (player) => {
    return {
        type: GET_PLAYER_LIST_SUCCESS,
        payload: player
    }
}

export const getPlayerListFailed= () => {
    return {
        type: GET_PLAYER_LIST_FAILED
    }
}

export const getDetailedCampains = (player) => {
    return {
        type: GET_DETAILED_CAMPAIGN,
        payload: player
    }
}
export const getDetailedCampainsSuccess = (campaigns) => {
    return {
        type: GET_DETAILED_CAMPAIGN_SUCCESS,
        payload: campaigns
    }
}

export const getDetailedCampainsFailed= () => {
    return {
        type: GET_DETAILED_CAMPAIGN_FAILED
    }
}
